import { API } from "./api";

export const getScreensByOwner = (ownerId) =>
  API.get(`/owners/screens/${ownerId}`);

export const getScreenById = (screenId) => API.get(`screens/${screenId}`);
export const getMonthlyScreenCount = (screenId) =>
  API.get(`screens/calculateMonthlyScreenCount/${screenId}`);
export const getPositionLogs = (id) => API.get(`/screens/${id}/position-logs`);
export const addScreen = (screen) => API.post(`/screens`, screen);
export const deleteScreen = (screenId) => API.delete(`/screens/${screenId}`);
export const updateScreen = (screenId, screen) =>
  API.put(`/screens/${screenId}`, screen);
